import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9daa32a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold text-center text-indigo-900 mb-12" }, "SchoolMeet.AI", -1))
const _hoisted_2 = {
  id: "login-screen",
  class: "p-8 rounded-2xl bg-white shadow max-w-sm w-full mx-auto"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold text-black mb-6" }, "Create New Password", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "relative mb-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-gray-700 font-medium mb-2"
}, "Password", -1))
const _hoisted_7 = ["type"]
const _hoisted_8 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: "{1.5}",
  stroke: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: "{1.5}",
  stroke: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-gray-700 font-medium mb-2 mt-4"
}, "Password (Again)", -1))
const _hoisted_16 = ["type"]
const _hoisted_17 = {
  type: "submit",
  class: "w-full rounded-md bg-indigo-600 px-6 py-3 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  "aria-hidden": "true",
  role: "status",
  class: "inline mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "#1C64F2"
}, null, -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-green-500 font-bold" }, " Your password has been reset successfully. ", -1))
const _hoisted_25 = { class: "text-center pt-8" }
const _hoisted_26 = { class: "w-full rounded-md bg-indigo-600 px-6 py-3 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.isPasswordCreated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("form", {
              id: "login-form",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
                  type: _ctx.passwordVisible ? 'text' : 'password',
                  class: "w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                  required: ""
                }, null, 8, _hoisted_7), [
                  [_vModelDynamic, _ctx.newPassword]
                ]),
                _createElementVNode("span", {
                  class: "absolute inset-y-0 right-0 -top-14 flex items-center px-4 text-gray-600",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                }, [
                  (_ctx.passwordVisible)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_14))
                ]),
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                  type: _ctx.passwordVisible ? 'text' : 'password',
                  class: "w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                  required: ""
                }, null, 8, _hoisted_16), [
                  [_vModelDynamic, _ctx.confirmPassword]
                ])
              ]),
              _createElementVNode("button", _hoisted_17, [
                (!_ctx.isFetching)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Reset Password"))
                  : _createCommentVNode("", true),
                (_ctx.isFetching)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_22))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", _hoisted_26, [
                _createVNode(_component_router_link, { to: "/auth/login" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Login")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
    ])
  ], 64))
}